/**
 * 应用配置管理
 * 根据环境变量自动切换 Mock/正式 API
 */

export const config = {
  /** 是否使用Mock数据 */
  useMock: import.meta.env.VITE_USE_MOCK === 'true',
  
  /** API基础URL */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '',
  
  /** 请求超时时间（毫秒） */
  timeout: 10000,
  
  /** JWT过期天数 */
  jwtExpiresDays: Number(import.meta.env.VITE_JWT_EXPIRES_DAYS) || 365,
};

/** 赛事相关常量配置 */
export const competitionConfig = {
  /** 报名截止日期 */
  registrationDeadline: '2026-02-15T23:59:59+08:00',
  
  /** 培训开始日期 */
  trainingStartDate: '2026-02-16',
  
  /** 培训结束日期 */
  trainingEndDate: '2026-03-31',
  
  /** 学段选项 */
  studentLevels: ['小学', '初中', '高中', '中职', '高职'] as const,
};

export type StudentLevel = typeof competitionConfig.studentLevels[number];
